
import { onMounted, onUnmounted, reactive, toRefs } from 'vue';
import moment from 'moment';
import { isMinStatus, newTerminalInfo, getCookieId } from './util';
import { nanoid } from 'nanoid';
import axios from 'axios';
import Fingerprint from 'fingerprintjs';
import Cookies from 'js-cookie';

export default {
  name: 'sendMetrics',
  components: {},
  props: ['channel', 'targetUrl'],
  setup(props) {
    const userInfo = Cookies.get('userInfo');
    let userId = 'guest';

    if (userInfo) {
      userId = JSON.parse(userInfo).id;
    }

    onMounted(() => {
      if (!getCookieId()) {
        const temp = nanoid();
        sessionStorage.setItem('sessionId', temp);
      }
      if (!localStorage.getItem('uuid')) {
        localStorage.setItem('uuid', `${new Fingerprint().get()}`);
      }
      const time = moment().format('YYYY-MM-DD HH:mm:ss');
      window.localStorage.setItem('beforeTime', time);
      document.addEventListener('click', data.setClickTime);
      data.sendTime();
      setTimeout(() => {
        const loadTime =
          window.performance.timing.loadEventEnd -
          window.performance.timing.fetchStart;
        const referrer = document.referrer ? document.referrer : '直接访问';
        const obj = {
          userId,
          cookieId: getCookieId(),
          clientType: newTerminalInfo(),
          uuid: localStorage.getItem('uuid'),
          lang: localStorage.getItem('locale') || 'en-US',
          url: window.location.href,
          preUrl: referrer,
          eventType: 'loadTime',
          channel: props.channel,
          utlogMap: `{loading_time: ${loadTime}}`,
        };
        axios({
          method: 'POST',
          url: props.targetUrl,
          data: obj,
          headers: {
            'Content-Type': 'application/json',
            'dde-ananlytics-utlog-api-key': Cookies.get('apiKey'),
          },
        });
      }, 20000);
    });

    onUnmounted(() => {
      document.removeEventListener('click', data.setClickTime);
    });

    const data = reactive({
      interval: '' as any,
      setClickTime: () => {
        const time = moment().format('YYYY-MM-DD HH:mm:ss');
        window.localStorage.setItem('beforeTime', time);
      },
      sendTime: () => {
        data.interval = setInterval(() => {
          if (isMinStatus()) {
            console.log('是最小化', isMinStatus());
          } else {
            const beforeTime = window.localStorage.getItem('beforeTime');
            const time = moment().format('YYYY-MM-DD HH:mm:ss');
            const timeDiff = moment(time).diff(beforeTime, 'minute');
            const referrer = document.referrer ? document.referrer : '直接访问';

            if (timeDiff > 20) {
              return;
            }
            //发送
            axios({
              method: 'POST',
              url: props.targetUrl,
              data: {
                url: window.location.href,
                userId,
                cookieId: getCookieId(),
                eventType: 'visitTime',
                uuid: localStorage.getItem('uuid'),
                clientType: newTerminalInfo(),
                lang: localStorage.getItem('locale') || 'en-US',
                preUrl: localStorage.getItem('preUrl') ?? referrer,
                channel: props.channel,
              },
              headers: {
                'Content-Type': 'application/json',
                'dde-ananlytics-utlog-api-key': Cookies.get('apiKey'),
              },
            });
          }
        }, 60000);
      },
      clearInterval: () => {
        if (data.interval) {
          clearInterval(data.interval);
          data.interval = null;
        }
      },
    });
    
    return {
      ...toRefs(data),
    };
  },
};
